<template>
    <v-card flat>
        <Alert :showErrorAlert="showErrorAlert" :textError="textError" v-on:onClose="closeAlert" />
        <v-card-title class="align-baseline">
            <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                            v-model="dateRangeText"
                            label="Choose the date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :disabled="loading"
                    ></v-text-field>
                </template>
                <v-date-picker
                        no-title
                        v-model="date"
                        @change="handleChangeDate"
                        scrollable
                        range
                ></v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    :disabled="loading"
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="unmappedDomainsData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                hide-default-footer
        >
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="openEditItem(item)"
                        title="Assign domain to vendor"
                >
                    mdi-card-plus
                </v-icon>
                <v-icon
                        small
                        @click="openDeleteItem(item)"
                        title="Delete domain"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center" v-if="unmappedDomainsData.length">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                        :disabled="loading"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 'All']"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                        :disabled="loading"
                ></v-select>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogCreate" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="create"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">{{ formTitle }}</v-card-title>
                    <v-card-text>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <div class="pb-3"><b>Domain name: </b> {{newDomain.hostname}}</div>
                                    <v-autocomplete
                                            v-model="newDomain.vendor"
                                            :items="getAllVendors"
                                            placeholder="Search vendor by name"
                                            item-value="id"
                                            item-text="name"
                                            required
                                            dense
                                            label="Vendor"
                                            :rules="[autocompleteRule]"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-model="newDomain.technology_fk"
                                            :items="getVendorsTechnologies"
                                            placeholder="Technology"
                                            label="Technology"
                                            item-value="id"
                                            item-text="name"
                                            required
                                            dense
                                            :rules="[autocompleteRule]"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" align="right">
                                    <v-btn color="red darken-1" text @click="closeCreate">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="delete"
                        v-model="deleteValid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">Confirm delete domain</v-card-title>
                    <v-card-text>
                        <div>Please, enter 'Delete {{domainName}}' in the text field to confirm domain deletion</div>
                        <v-text-field
                                v-model="confirmDelete"
                                label="Delete domain"
                                :rules="[deleteRule]"
                                single-line
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteDomain">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import Alert from '../../common/Alert'
    import { createNamespacedHelpers } from "vuex";
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    import adminDashboardApi from '../../../api/adminDashboard'
    export default {
        components: {Alert},
        name: 'UnmappedDomains',
        computed:{
            ...adminDashboardHelper.mapGetters(["getUnmappedDomains", "getVendorsTechnologies", "getAllVendors"]),
            formTitle () {
                return this.editedIndex === -1 ? 'CREATE DOMAIN' : 'ASSIGN DOMAIN TO VENDOR'
            },
            dateRangeText () {
                return this.date.join(' ~ ')
            },
        },
        data () {
            return {
                search: '',
                headers: [
                    { text: 'Domain', align: 'start', value: 'domain', sortable: false },
                    { text: 'Drops cookie', value: 'drops_cookie', sortable: false },
                    { text: 'Scan prevalence', value: 'scan_prevalence', sortable: false },
                    { text: 'Websites', value: 'websites' , sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false }
                ],
                unmappedDomainsData: [],
                dialogCreate: false,
                dialogDelete: false,
                loading: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                newDomain: {
                    vendor: '',
                    hostname: '',
                    technology_fk: '',
                    server_location: ''
                },
                domainName: '',
                editedIndex: -1,
                autocompleteRule: v =>{
                    if (v && Object.keys(v).length !== 0) return true;
                    return 'This field is required';
                },
                deleteRule: v =>{
                    if (!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required';
                    } else if(!(v && this.confirmDelete.includes(`Delete ${this.domainName}`))){
                        return 'The confirmation message must meet the requirements';
                    } return true;
                },
                confirmDelete: '',
                valid: true,
                deleteValid: true,
                date: [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
                menu: false,
                showErrorAlert: false,
                textError: '',
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchUnmappedDomains", "fetchVendorTechnologies", "fetchAllVendors"]),
            getVendorTechnologiesData(){
                this.fetchVendorTechnologies()
            },
            getAllVendorsData(){
                this.fetchAllVendors({pagination: false});
            },
            async getUnmappedDomainsDashboard(){
                this.loading = true;
                try{
                    this.showErrorAlert = false;
                    await this.fetchUnmappedDomains({
                        page: this.page,
                        page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                        s: this.search,
                        date_filter_from: this.date[0],
                        date_filter_to: this.date[1]
                    })
                }
                catch(err){
                    this.unmappedDomainsData = [];
                    this.textError = err.response && err.response.status === 408 ? err.response.data.detail : err;
                    this.showErrorAlert = true;
                }

                this.loading = false;
            },
            openEditItem(domain){
                this.editedIndex = this.unmappedDomainsData.indexOf(domain);
                this.newDomain = Object.assign({},
                    {
                        vendor: '',
                        hostname: domain.domain,
                        technology_fk: '',
                        server_location: ''
                    }
                );
                this.dialogCreate = true;
            },
            closeCreate () {
                this.dialogCreate = false;
                this.newDomain = {
                    vendor: '',
                    hostname: '',
                    technology_fk: '',
                    server_location: ''
                };
                this.$refs.create.resetValidation();
                this.showErrorAlert = false;
            },
            async save(){
                if(this.$refs.create.validate()){
                    try{
                        this.showErrorAlert = false;
                        await adminDashboardApi.createDomain(this.newDomain);
                        this.closeCreate();
                        this.getUnmappedDomainsDashboard();
                    }catch(err){
                        this.textError = err.response ? err.response.data.detail : err;
                        this.showErrorAlert = true;
                    }
                }
            },
            openDeleteItem(vendor){
                this.domainName = vendor.domain;
                this.dialogDelete = true
            },
            closeDelete(){
                this.dialogDelete = false;
                this.confirmDelete = '';
                this.$refs.delete.resetValidation();
                this.showErrorAlert = false;
            },
            async deleteDomain(){
                if(this.$refs.delete.validate()){
                    if(this.confirmDelete.includes(`Delete ${this.domainName}`)){
                        try{
                            this.showErrorAlert = false;
                            await adminDashboardApi.deleteUnmappedDomain({domain: this.domainName});
                            this.closeDelete();
                            this.getUnmappedDomainsDashboard();
                        }catch(err){
                            this.textError = err;
                            this.showErrorAlert = true;
                        }
                    }
                }
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                if(itemsPerPage === 'All'){
                    this.itemsPerPage = this.totalCount;
                } else {
                    this.itemsPerPage = itemsPerPage;
                }
                this.getUnmappedDomainsDashboard();
            },
            onChangePagination(){
                this.getUnmappedDomainsDashboard();
            },
            handleChangeDate(date) {
                this.showErrorAlert = false;
                if(date[0] > date[1]){
                    this.date = [date[1],date[0]];
                    this.menu = false;
                }else{
                    this.date = date;
                    this.menu = false;
                }
                let startDate = new Date(this.date[0]);
                let endDate = new Date(this.date[1]);
                let diffDate = parseInt((endDate - startDate) / (1000 * 60 * 60 * 24), 10);
                if(Math.abs(diffDate) > 7){
                    this.textError = 'Selected date range must be less than 7 days!';
                    this.showErrorAlert = true;
                    this.date = []
                }
            },
            closeAlert(){
                this.showErrorAlert = false;
            }
        },
        created () {
            this.getUnmappedDomainsDashboard();
            this.getVendorTechnologiesData();
            this.getAllVendorsData();
        },
        watch: {
            getUnmappedDomains: function(e){
                this.unmappedDomainsData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getUnmappedDomainsDashboard();
            },
            date: function(date) {
                if (date && date.length > 1) {
                    this.getUnmappedDomainsDashboard();
                }
            },
        }
    }
</script>
